export const templateTypes = [
  { id: 1, name: 'Email', value: 'Email' },
  { id: 2, name: 'Text', value: 'Text' },
  { id: 3, name: 'Phone', value: 'Phone' },
];
